import { useCallback, useRef, useState } from 'react';
export function useAccountsPayableTransaction({ accountPayable, onPay, onDelete }) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const handleClickOutside = useCallback((event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    }, []);
    const handleThreeDotsClick = useCallback((e) => {
        e.stopPropagation();
        setIsDropdownOpen(prev => !prev);
    }, []);
    const handlePayClick = useCallback((e) => {
        e.stopPropagation();
        setIsDropdownOpen(false);
        onPay?.(accountPayable);
    }, [accountPayable, onPay]);
    const handleDeleteClick = useCallback((e) => {
        e.stopPropagation();
        setIsDropdownOpen(false);
        onDelete?.(accountPayable);
    }, [accountPayable, onDelete]);
    const closeDropdown = useCallback(() => {
        setIsDropdownOpen(false);
    }, []);
    return {
        isDropdownOpen,
        dropdownRef,
        handleClickOutside,
        handleThreeDotsClick,
        handlePayClick,
        handleDeleteClick,
        closeDropdown,
    };
}
